<template>
  <base-card noPadding class="tw-h-full tw-flex tw-flex-col tw-rounded-md">
    <img class="tw-rounded-t-md" :src="imgSrc" :style="{ height: '180px', width: '100%' }" style="object-fit:cover" />
    <base-content class="tw-flex-grow tw-w-full">
      <div class="tw-text-lg tw-text-gray-700 tw-font-normal">{{ name }}</div>
      <div class="tw-text-sm tw-text-gray-500 tw-mt-2 tw-flex-grow">{{ description }}</div>
    </base-content>
    <base-content class="tw-pt-0 tw-w-full">
      <div class="tw-flex tw-my-auto">
        <base-button class="tw-grow tw-w-full tw-mr-2" color="primary" type="secondary" @click="viewDocument()">
          <template v-slot:icon>
            <eye-icon />
          </template>
          View
        </base-button>
        <base-icon v-if="canManage === false" color="gray" :loading="isLoading" @click="download">
          <download-icon class="tw-h-5 tw-w-5" />
        </base-icon>
        <base-dropdown class="tw-my-auto" v-else :options="['Download', 'Edit', 'Delete']" :showBackground="false" color="gray" type="text" align="right">
          <base-icon color="gray" :loading="isLoading">
            <more-vertical-icon class="tw-h-5 tw-w-5" />
          </base-icon>

          <template #option="{ option: link }">
            <button
              class="tw-flex tw-items-center tw-w-full tw-text-left tw-px-4 tw-py-2 tw-text-sm tw-text-gray-600 focus:tw-outline-none"
              @click="link === 'Download' ? download() : link === 'Edit' ? edit() : del()"
            >
              {{ link }}
            </button>
          </template>
        </base-dropdown>
      </div>
    </base-content>
    <document-modal ref="documentModal" />
    <edit-training
      ref="editModal"
      :businessId="businessId"
      :trainingId="id"
      :name="name"
      :category="category"
      :description="description"
      :sort-order="sortOrder"
      :documentId="documentId"
      :document-extension="documentExtension"
      :imageDocumentId="imageDocumentId"
      :imageExtension="imageExtension"
      @saved="refresh"
    />
    <delete-training ref="deleteModal" :businessId="businessId" :trainingId="id" :name="name" @deleted="refresh" />
  </base-card>
</template>
<script>
import { mapGetters } from "vuex";
import DocumentModal from "@/components/DocumentModal";
import EditTraining from "@/views/business/training/components/EditTraining";
import DeleteTraining from "@/views/business/training/components/DeleteTraining";
import { DownloadIcon, EyeIcon, MoreVerticalIcon } from "@/assets/svgs";

export default {
  name: "TrainingCard",
  components: { EditTraining, DeleteTraining, DocumentModal, DownloadIcon, EyeIcon, MoreVerticalIcon },
  props: {
    id: String,
    businessId: String,
    name: String,
    category: String,
    description: String,
    sortOrder: Number,
    documentId: String,
    documentExtension: String,
    imageDocumentId: String,
    imageExtension: String,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    imgSrc() {
      return `/api/uploads/documents/${this.imageDocumentId}.${this.imageExtension}`;
    },
    ...mapGetters("role", ["isLocationFiltered", "isBusinessManagement", "isPredictile"]),
    canManage() {
      if ((this.isLocationFiltered === false && this.isBusinessManagement(this.businessId) === true) || this.isPredictile() === true) return true;
      else return false;
    },
  },
  methods: {
    refresh() {
      this.$emit("refresh");
    },
    dropdownLink(name) {
      switch (name) {
        case "Download":
          return;
      }
    },
    download() {
      this.isLoading = true;
      this.$axios
        .get(`/documents/${this.documentId}`)
        .then((res) => {
          this.$axios
            .get(res.data.downloadUrl, { responseType: "blob" })
            .then((response) => {
              var blob = new Blob([response.data]);
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = this.name + "." + res.data.extension;
              link.click();
              URL.revokeObjectURL(link.href);
            })
            .finally(() => {
              this.isLoading = false;
            });
        })
        .catch((err) => {
          this.error = err;
          this.isLoading = false;
        });
    },
    viewDocument() {
      this.$refs.documentModal.show({
        documentId: this.documentId,
        extension: this.documentExtension,
      });
    },
    edit() {
      this.$refs.editModal.show();
    },
    del() {
      this.$refs.deleteModal.show();
    },
  },
};
</script>
